<template>
	<sf-modal-layout class="qms-xxl" :title="getMessage_('QWCC001854')" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<as-part-popup-search ref="PartPopupSearch" :scrId="scrId" :partNum="propPartNo" />
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<as-part-popup-table ref="table" @close="close" @reload="reload" @SendPartData="sendPartData" :scrId="scrId" />
				</sf-card>
			</div>
		</div>
		<template v-slot:footer>
			<sf-button line :onClick="close">
				{{ getMessage_('MWCC000343') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/AsPartPopup/store/helpers';
import AsPartPopupTable from './Content/Table/AsPartPopupTable.vue';
import AsPartPopupSearch from './Content/Search/AsPartPopupSearch.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { AsPartPopupTable, AsPartPopupSearch },

	data() {
		return {
			show: false,
			propPartNo: '',
			cmpnNoInfo: false,
			pwaYn: 'N'
		};
	},
	created() {
		//들어오자마자 state 초기화 하는 방법
		this.setStateInit_();
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			this.$sf_toggleLoading(true);
			this.setStateInit_();
			this.getCommCodes_({ key: 'opCdList', codeType: 'OP_CD' }); //OP코드;
			this.show = true;
			this.propPartNo = param.partNoInput;
			this.cmpnNoInfo = param.cmpnNoInfo;
			this.pwaYn = param.pwaYn;

			this.setSearchParam_({ key: 'partNo', value: this.propPartNo });

			/*PWA신청에서만 사용 */
			if (this.pwaYn == 'Y') {
				this.setSearchParam_({ key: 'pwaYn', value: this.pwaYn });
			}

			if (param.opCd) {
				this.cmpnNoOpCd = param.opCd;
				this.setSearchParam_({ key: 'opCd', value: this.cmpnNoOpCd });
			}

			if (this.$refs.PartPopupSearch != undefined) {
				this.$refs.PartPopupSearch.search();
			}
			this.$sf_toggleLoading(false);
		},
		close() {
			//this.setSearchParam_({ key: 'partNo', value: null });
			//this.$refs.PartPopupSearch.reset();
			this.show = false;
		},
		//partPopupSearch페이지 새로고침
		reload() {
			this.$refs.PartPopupSearch.search();
		},
		sendPartData(sendParam) {
			if (this.cmpnNoInfo) {
				//캠페인이 선택되었을 경우
				this.$emit('SendPartData', sendParam);
			} else {
				//캠페인이 선택되지 않았을 경우
				if (sendParam.pwaYn == 'Y') {
					//PWA대상입니다.
					this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001871') });
					return;
				} else {
					this.$emit('SendPartData', sendParam);
				}
			}
			this.close();
		}
	}
};
</script>

<style></style>
